import {
  Table,
  TableContainer,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";
import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
import UtilService from "services/util.service.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Pagination from "components/dataDispaly/Pagination";
import HeaderBillOkData from "./HeaderBillOkData";

// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
export default function BillOkData(props) {
  // custom variable

  let DateFrom = UtilService.dateFrom;
  let DateTo = UtilService.dateTo;

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputDateFrom, setDateFrom] = useState(DateFrom);
  const [inputDateTo, setDateTo] = useState(DateTo);
  const [inputBill, setInputBill] = useState("");
  const [inputBranch, setInputBranch] = useState("");
  const [inputBranchName, setInputBranchName] = useState("");
  const [urlExcel, setUrlExcel] = useState("");

  // Ref variable
  const skipPageResetRef = React.useRef();

  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   try {
  //     const fetchData = async () => {
  //       try {
  //         skipPageResetRef.current = true;
  //         let response = await ApiService.client.get(
  //           `/dataCore/getAllDataCoreOK/${
  //             pageIndex + 1
  //           }/${dataPageSize}/${
  //             inputBranch === "" ? ApiService.firstBranch() : inputBranch
  //           }/${
  //             inputBill === "" ? "all" : inputBill
  //           }/${inputDateFrom}/${inputDateTo}`,
  //           await ApiService.options()
  //         );

  //         setDataPage(response.data["total_halaman"]);
  //         setPageSize(dataPageSize);
  //         setData(response.data.data);
  //         skipPageResetRef.current = false;

  //       } catch (error) {
  //         if (error.response.status === 401) {
  //           // AuthService.logout().then(
  //           //   () => {
 //           //     console.log("Success Logout");
  //           //   },
  //           //   (error) => {
  //           //     const resMessage =
  //           //       (error.response &&
  //           //         error.response.data &&
  //           //         error.response.data.message) ||
  //           //       error.message ||
  //           //       error.toString();
  //           //   }
  //           // );
  //           // history.push("/auth/sign-in");
  //         }
  //       }
  //     };
  //     setUrlExcel(ApiService.excel+`/dataCore/exportAllDataCoreOK/${
  //       inputBranch === "" ? "all" : inputBranch
  //     }/${
  //       inputBill === "" ? "all" : inputBill
  //     }/${inputDateFrom}/${inputDateTo}`)
 //     // console.log("iasdsni url excxel", urlExcel)
  //     fetchData();
  //   } catch (error) {
  //     if (error.response.status === 401) {
  //       // history.push("/auth/sign-in");
  //     }
  //   }
  // }, [
  //   pageIndex,
  //   dataPage,
  //   dataPageSize,
  //   pageSize,
  //   inputDateFrom,
  //   inputDateTo,
  //   inputBill,
  //   inputBranch,
  // ]);

  //Branch Data
  const options = ApiService.optionsBranch()

  useEffect(() => {
    setLoading(true);  // Assume setLoading exists

    const fetchData = async () => {
      try {
        skipPageResetRef.current = true;
        const requestOptions = await ApiService.options();
        let response = await ApiService.client.get('/dataCore/getAllDataCoreOK', {
          params: {
            page: pageIndex + 1,
            limit: dataPageSize,
            branch_ids: inputBranch === "" ? options?.map(data => data.id).join(',') : inputBranch,
            branch_name: inputBranchName === "" ? "" : inputBranchName,
            bill_id: inputBill === "" ? "" : inputBill,
            from_order_date: inputDateFrom,
            to_order_date: inputDateTo
          }, ...requestOptions
        });
        // }, await ApiService.options());

        setDataPage(response.data["total_halaman"]);
        setPageSize(dataPageSize);
        setData(response.data.data);
        skipPageResetRef.current = false;
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            // console.log("Unauthorized access detected");
            // Logout and redirect to login page
            try {
              await AuthService.logout();
              // console.log("Success Logout");
              history.push("/auth/sign-in");
              return; // Exit early to prevent further execution
            } catch (logoutError) {
              const resMessage =
                (logoutError.response &&
                  logoutError.response.data &&
                  logoutError.response.data.message) ||
                logoutError.message ||
                logoutError.toString();
              // console.log("Logout error:", resMessage);
              // Even if logout fails, still redirect to login
              history.push("/auth/sign-in");
              return;
            }
          } else {
            // console.log("Server error:", error.response.status, error.response.data);
          }
        } else if (error.request) {
          // Request was made but no response received
          // console.log("Network error - no response received:", error.request);
        } else {
          // Something else caused the error
          // console.log("Error:", error.message);
        }
      } finally {
        setLoading(false);
      }
    };

    // Set URL Excel tanpa try-catch
    const excelUrl = ApiService.excel + '/dataCore/exportAllDataCoreOK?' +
      'branch_ids=' + (inputBranch === ''
        ? options?.map(data => data.id).join(',')
        : inputBranch) + '&' +
      'branch_name=' + (inputBranchName === '' ? '' : inputBranchName) + '&' +
      'bill_id=' + (inputBill === '' ? '' : inputBill) + '&' +
      'from_order_date=' + inputDateFrom + '&' +
      'to_order_date=' + inputDateTo;
    setUrlExcel(excelUrl);

    fetchData();

  }, [
    pageIndex,
    dataPage,
    dataPageSize,
    pageSize,
    inputDateFrom,
    inputDateTo,
    inputBill,
    inputBranch,
    inputBranchName,
    setPageSize,
    history,
  ]);

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", lg: "hidden" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          Bill Ok Data
        </Text>
        <Menu urlExcel={urlExcel} />
      </Flex>

      <HeaderBillOkData
        inputDateFrom={inputDateFrom}
        inputDateTo={inputDateTo}
        inputBill={inputBill}
        inputBranch={inputBranch}
        inputBranchName={inputBranchName}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        setBill={setInputBill}
        setInputBranch={setInputBranch}
        setInputBranchName={setInputBranchName}
      />

      <TableContainer>
        <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
          <Thead>
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                    borderColor={borderColor}
                  >
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color="gray.400"
                    >
                      {column.render("Header")}
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>
          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "ORDER DATE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "EI TA") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "BILL ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "SEQ") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "CUSTOMER TYPE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PAYMENT METHOD") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "POS ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "BRANCH ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "BRANCH NAME") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PAKET ADDON") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PARENT ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "ERP ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "DESCRIPTION") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "QTY") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "UNIT PRICE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "EXT PRICE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "DISCOUNT PERCENT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "TOTAL DISCOUNT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "AMOUNT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "ID ITEM POS") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PB1") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "TAX AMOUNT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "NOTES PRODUCT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "CATEGORY") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "SUB CATEGORY") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "ORDER BEGIN") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "ORDER END") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "NIK CASHIER") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "NAMA CASHIER") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "MEMBER CARD NO") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "STATUS ITEM") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "CANCEL REASON ITEM") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "BILL STATUS") {
                      data = (
                        <Flex align="center">
                          <Icon
                            w="24px"
                            h="24px"
                            me="5px"
                            color={
                              cell.value === "OK"
                                ? "green.500"
                                : cell.value === "Cancel"
                                  ? "red.500"
                                  : cell.value === "Error"
                                    ? "orange.500"
                                    : null
                            }
                            as={
                              cell.value === "OK"
                                ? MdCheckCircle
                                : cell.value === "Cancel"
                                  ? MdCancel
                                  : cell.value === "Error"
                                    ? MdOutlineError
                                    : null
                            }
                          />
                          <Text
                            color={textColor}
                            fontSize="sm"
                            fontWeight="700"
                          >
                            {cell.value}
                          </Text>
                        </Flex>
                      );
                    } else if (cell.column.Header === "CANCEL REASON ORDER") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "SHIFT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "START TIME") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "DATE CREATED") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "POS VERSION") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PAYMENT AMOUNT") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PAYMENT USED") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "PAYMENT REF") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    else if (cell.column.Header === "APPROVAL CODE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    else if (cell.column.Header === "TRANSACTION DATE") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    else if (cell.column.Header === "TRANSACTION TIME") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    else if (cell.column.Header === "MERCHANT ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    else if (cell.column.Header === "TERMINAL ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    else if (cell.column.Header === "CUSTOMER TYPE REFF ID") {
                      data = (
                        <Text color={textColor} fontSize="sm" fontWeight="700">
                          {cell.value}
                        </Text>
                      );
                    }
                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor="transparent"
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <Pagination
        canNextPage={canNextPage}
        nextPage={nextPage}
        canPreviousPage={canPreviousPage}
        previousPage={previousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        gotoPage={gotoPage}
        pageSize={pageSize}
        setDataPageSize={setDataPageSize}
        pageCount={pageCount}
      />
    </Card>
  );
}
